import { render, staticRenderFns } from "./CourseEditTabInformation.vue?vue&type=template&id=485dcadb&scoped=true&"
import script from "./CourseEditTabInformation.vue?vue&type=script&lang=js&"
export * from "./CourseEditTabInformation.vue?vue&type=script&lang=js&"
import style0 from "./CourseEditTabInformation.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./CourseEditTabInformation.vue?vue&type=style&index=1&id=485dcadb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485dcadb",
  null
  
)

export default component.exports